import { createSlice, createAsyncThunk, isFulfilled } from '@reduxjs/toolkit'
import axios from 'axios'
import {host} from '../../function/api'

const initialState = {
    attachments: [],
    documentRow: [],
    document: [],
    documentTransfers: [],
    status: false,
    loading: false,
    success: false,
    message: '',
    documentId: '',
    customerStore: false,
    errorName: '',
    errorFamily: '',
    errorNationalCode: '',
    errorNumberType: '',
    errorNumber: '',
    errorFather: '',
    errorBirthplace: '',
    errorIdcard: '',
    errorBirthregistrationdate: '',
    errorPlaceofissue: '',
    errorMobile: '',
    errorPostalcode: '',
    errorPhone: '',
    errorAddress: ''
};

export const documentAttachments = createAsyncThunk(
    'documentAttachments',
    async(data, thunkAPI) => {
        try{
            const response = await axios({
                method: 'POST',
                url: `${host}document/transfer/attachments`,
                data: data,
                headers:{
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true, 
                }
            })

            return await response.data
            
        } catch(error) {
            return thunkAPI.rejectWithValue(error);
        }

    }
)

export const documentTransferIndex = createAsyncThunk(
    'documentTransferIndex',
    async(document_id, thunkAPI) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}document/transfers`,
                data: document_id,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,     
                }
            })

            return response.data;
            
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

export const documentFind = createAsyncThunk(
    'documentFind',
    async(data, thunkAPI) => {
        try{
            const response = await axios({
                method: 'POST',
                url: `${host}document/find`,
                data: data,
                headers:{
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true, 
                }
            })

            return await response.data
            
        } catch(error) {
            return thunkAPI.rejectWithValue(error);
        }

    }
)
export const documentTransferStore = createAsyncThunk(
    'document/transfer/store',
    async(data, thunkAPI) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}documentTransfer`,
                data: data, 
                headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            return await response.data

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
)

const documentTransferSlice = createSlice({
    name: 'documentTransfer',
    initialState,
    reducers: {},
    extraReducers: {
        [documentTransferIndex.fulfilled]: (state, action) => {
            state.loading = false
            state.document = action.payload.data[0].document
            state.documentTransfers = action.payload.data
        },
        [documentTransferIndex.pending]: (state) => {
            state.loading = true
        },
        [documentTransferIndex.rejected]: (state, {payload}) => {
            state.loading = false;
            state.success = false
            if(payload.response.data.error){
                state.error = payload.response.data.error
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        },
        [documentTransferStore.fulfilled] : (state, {payload}) => {
            state.loading = false
            state.success = true
            state.customerStore = true
            state.message = payload.message
        },
        [documentTransferStore.pending] : (state) => {
            state.loading = true
            state.success = false
        },
        [documentTransferStore.rejected] : (state, {payload}) => {
            state.loading = false
            state.success = false
            if(payload.response.data.error){
                state.errorDocumentId = payload.response.data.error.documentId
                state.errorPreviousId = payload.response.data.error.previousId
                state.nameError = payload.response.data.error.name
                state.familyError = payload.response.data.error.family
                state.errorNationalCode = payload.response.data.error.nationalCode
                state.errorNumberType = payload.response.data.error.numberType
                state.errorNumber = payload.response.data.error.number
                state.errorFather = payload.response.data.error.father
                state.errorBirthplace = payload.response.data.error.birthplace
                state.errorIdcard = payload.response.data.error.idcard
                state.errorBirthregistrationdate = payload.response.data.error.birthregistrationdate
                state.errorPlaceofissue = payload.response.data.error.placeofissue
                state.errorMobile = payload.response.data.error.mobile
                state.errorPostalcode = payload.response.data.error.postalcode
                state.errorPhone = payload.response.data.error.phone
                state.errorAddress = payload.response.data.error.address
            }else if(payload.response.data.message) {
                state.message = payload.response.data.message
            }
        },
        [documentFind.fulfilled]: (state, action) => {
            state.loading = false;
            state.success = true;
            state.status = action.payload.status
            state.documentRow = action.payload.data
            if(action.payload.message)
            state.message = action.payload.message;
        },
        [documentFind.pending]: (state) => {
            state.loading = true
            state.success = false;
        },
        [documentFind.rejected]: (state, action) => {
            state.loading = false;
            state.success = false
            state.status = false
            if(action.payload.response.data.error){
                state.errorNumberType = action.payload.response.data.error.numberType
                state.ErrorNumber = action.payload.response.data.error.number
            } else if (action.payload.response.data.message) {
                state.message = action.payload.response.data.message
            }
        },
        [documentAttachments.fulfilled]: (state, action) => {
            state.loading = false;
            state.success = true;
            state.status = action.payload.status
            state.attachments = action.payload.data
            if(action.payload.message)
            state.message = action.payload.message;
        },
        [documentAttachments.pending]: (state) => {
            state.loading = true
            state.success = false;
            state.attachments = [];
        },
        [documentAttachments.rejected]: (state, action) => {
            state.loading = false;
            state.success = false
            state.status = false
            if(action.payload.response.data.error){
                state.errorNumberType = action.payload.response.data.error.numberType
                state.ErrorNumber = action.payload.response.data.error.number
            } else if (action.payload.response.data.message) {
                state.message = action.payload.response.data.message
            }
        }
    }
})

export const {} = documentTransferSlice.actions;
export default documentTransferSlice.reducer;